import { render, staticRenderFns } from "./ComHeader.vue?vue&type=template&id=7cb8dd8e&scoped=true"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"
import style0 from "./ComHeader.vue?vue&type=style&index=0&id=7cb8dd8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb8dd8e",
  null
  
)

export default component.exports